import { useEffect, useState } from 'react';

import "@lindar-joy/goosicorn-quickies-library/lib/css/style.css";
import './App.css';

import { Game, useGameEventListener, emitGameAction, useCommonBalanceListener, useUiDisableListener, LoadAudio, PlayAudio, FadeAudio, useBfrStatusListener, Timeout } from "@lindar-joy/goosicorn-quickies-library";

import DiamondIcon from "./assets/UI/DiamondIcon.png";
import BombIcon from "./assets/UI/BombIcon.png";


import Block from './components/Block/Block';
import { BlockTypes } from './components/Block/Block.types';
import { ILevelConfig, IShowEvent } from './events/showEvent';
import { ISpotSelectedEvent } from './events/spotSelectedEvent';
import {
    MinesChoiceChip,
    StyledContainer,
    BlockContainer,
    StyledMultiplierBar,
    StyledMultiplierFrame,
    AddMines,
    Plus,
    NextMultiplierFrame,
    NextMultiplierText,
    NextMultiplier,
    StyledButton,
    Background,
    BackBushesBackground,
    RightOverlayContainer,
    LeftOverlayContainer,
    PhoneBackground,
    Porcupines,
    GridContainer,
} from './styles';
import MinesSelect from './components/MinesSelect/MinesSelect';
import { GameRules } from './gameRules';
import { GameHistoryRenderer } from './GameHistoryRenderer';
import Splash from './components/splash/Splash';
import ExplosionEffects from './components/Explosion/ExplosionEffects';
import Diamonds from './components/Diamonds/Diamonds';
import { useWindowSize } from '@uidotdev/usehooks';
import { formatCurrency } from './lib/utils';

export function getBlockType(playing: boolean, blockConfig: string, picked: boolean, gameRoundPending: boolean): BlockTypes {

    switch (blockConfig) {
        case "NON_DISCOVERED":
            if (gameRoundPending) {
                return "DEFAULT";
            }
            return playing ? "NON_DISCOVERED" : "DEFAULT";
        case "GOOD":
            return picked ? "GEM" : "REVEALED_GEM";
        case "BAD":
            return picked ? "BOMB" : "REVEALED_BOMB";
    }

    return "DEFAULT";
}

let roundStartTime: number;

function App() {

    let [loading, setLoading] = useState<boolean>(true);
    let [showEvent, setShowEvent] = useState<IShowEvent | ISpotSelectedEvent>();
    let [playing, setPlaying] = useState<boolean>(false);
    let [betAmount, setBetAmount] = useState<number>(0);
    let [freePlay, setFreePlay] = useState<boolean>(false);
    let [config, setConfig] = useState<ILevelConfig[]>([]);
    let [gameResults, setGameResults] = useState<string[]>([]);
    let [bets, setBets] = useState<number[]>([]);
    let [minesSelectOpen, setMinesSelectOpen] = useState<boolean>(false);
    let [mineCount, setMineCount] = useState<number>(0);
    let [playerPicks, setPlayerPicks] = useState<number[]>([]);
    let [sessionWinnings, setSessionWinnings] = useState<number>(0);
    let [sessionLosses, setSessionLosses] = useState<number>(0);
    let [level, setLevel] = useState<number>(0);
    let [balance, setBalance] = useState<number>(0);
    let [changeMinesDisabled, setChangeMinesDisabled] = useState<boolean>(false);
    let [pending, setPending] = useState<boolean>(false);
    let [bfrInUse, setBfrInUse] = useState<boolean>(false);
    let [bfrCount, setBfrCount] = useState<number>(0);
    let [showGame, setShowGame] = useState<boolean>(false);

    const size = useWindowSize();
    let width;
    let height;
    if (size.width && size.height) {
        width = size.width;
        height = size.height;
    }

    function collect() {
        emitGameAction({
            type: "mines:collect",
            body: {}
        });
    }

    function pickRandomCell(gameResults: string[], mineCount: number, bet: number) {
        let freeBlocks = gameResults.map((blockType, index) => { return { blockType, index } });
        freeBlocks = freeBlocks.filter(block => block.blockType === "NON_DISCOVERED");
        const blockId = freeBlocks[Math.floor(Math.random() * freeBlocks.length)].index;
        setPending(true);
        PlayAudio("Dig", false, 0.1);
        emitGameAction({
            "type": "mines:select-spot",
            body: {
                "spot": blockId,
                "difficulty": mineCount,
                "bet": bet
            }
        });
    }

    function onUndiscoveredClick(id: number, mineCount: number, bet: number) {
        setPending(true);
        PlayAudio("Dig", false, 0.1);
        emitGameAction({
            "type": "mines:select-spot",
            body: {
                "spot": id,
                "difficulty": mineCount,
                "bet": bet
            }
        })
    }

    function game(playing: boolean, level: number, betAmount: number, config: ILevelConfig[], gameResults: string[], mineCount: number, bet: number, playerPicks: number[], gameRoundPending: boolean, showEvent?: IShowEvent | ISpotSelectedEvent) {

        if (!showEvent) {
            return <StyledContainer></StyledContainer>;
        }

        
        const multiplier = config[mineCount].multipliers[level];
        
        const lastPick = playerPicks[playerPicks.length - 1];
        let bomb = gameResults[lastPick] === "BAD";
        let diamond = gameResults[lastPick] === "GOOD";
        const lastX = lastPick % 5;
        const lastY = Math.floor(lastPick / 5);
        const foundDiamonds: { x: number, y: number }[] = [];
        gameResults.forEach((result, index) => {
            if (result === "GOOD" && playerPicks.includes(index)) {
                foundDiamonds.push({ x: index % 5, y: Math.floor(index / 5) });
            }
        });


        return <StyledContainer>
            <GridContainer>
                <ExplosionEffects bombTriggered={bomb} explosionLocationX={lastX} explosionLocationY={lastY} />
                <Diamonds foundDiamonds={foundDiamonds} visible={true} bombTriggered={bomb} diamondFound={diamond} diamondLocationX={lastX} diamondLocationY={lastY} />
                <BlockContainer id="block-container">
                    {gameResults.map((blockConfig, index) => (
                        (
                            <Block
                                id={index}
                                key={index}
                                explosion={(bomb ? index === lastPick : undefined)}
                                type={getBlockType(playing, blockConfig, playerPicks.indexOf(index) >= 0, gameRoundPending)}
                                mineCount={mineCount}
                                bet={bet}
                                onClick={() => onUndiscoveredClick(index, mineCount, bet)}
                            />
                        )
                    ))}
                </BlockContainer>
            </GridContainer>
            <div style={{display: "flex", width: "100%", gap: "8px"}}>
                <StyledMultiplierBar>
                    <StyledMultiplierFrame>
                        <AddMines>
                            <Plus>
                                <img src={DiamondIcon} width={16} height={16} />
                                <span style={{ fontWeight: 700, lineHeight: "160%" }}>{25 - mineCount}</span>
                            </Plus>
                            <Plus>
                                <img src={BombIcon} width={20} height={20} />
                                <span style={{ fontWeight: 700, lineHeight: "160%" }}>{mineCount}</span>
                            </Plus>
                        </AddMines>
                        { playing && <NextMultiplierFrame>
                            <NextMultiplierText>Next win</NextMultiplierText>
                            <NextMultiplier>{ formatCurrency(multiplier * bet)}</NextMultiplier>
                        </NextMultiplierFrame> }
                        
                    </StyledMultiplierFrame>
                    
                </StyledMultiplierBar>
                <StyledButton size="lg" text="Pick random cell" disabled={!playing || gameRoundPending} onClick={() => pickRandomCell(gameResults, mineCount, bet)}></StyledButton>
            </div>
            
        </StyledContainer>;
    }

    useEffect(() => {
        (async () => {
            await LoadAudio([
                "music", "sfx"
            ]).catch( error => console.error(error));
            setLoading(false);
            PlayAudio("Porcupine Mines Full B (Loop)", true, 0);
            PlayAudio("Porcupine Mines Speed 2 (Loop)", true, 0);
            PlayAudio("Porcupine Mines Speed 3 (Loop)", true, 0);
            PlayAudio("Porcupine Mines Idle B (Loop)", true, 0.1);

            (async () => {
                setTimeout(() => setLoading(false), 1000);
                setTimeout(() => setShowGame(true), 3000);
            })();

        })();
    }, []);

    useCommonBalanceListener(balanceEvent => {
        setBalance(balanceEvent.amount);
    });

    useUiDisableListener((ui) => {
        setChangeMinesDisabled(ui.disabled);
    });

    useBfrStatusListener(status => {
        setBfrInUse(status.inUse);
        setBfrCount(status.bfrCount);
    });

    useGameEventListener((event) => {
        switch (event.type) {
            case "mines:show-event":
                const showEvent = event as IShowEvent;
                setShowEvent(showEvent);
                setBetAmount(showEvent.betAmount);
                setConfig(showEvent.config);
                setGameResults(showEvent.gameResults);
                setMineCount(showEvent.config[showEvent.difficulty].mines);
                setPlayerPicks(showEvent.playerPicks);
                setBets([10, 20, 50, 100, 500, 1000]);
                setLevel(showEvent.realWinnings > 0 ? 0 : showEvent.currentLevel);
                if (showEvent.gameState === "IN_PLAY") {
                    setPlaying(true);
                    if (showEvent.currentLevel >= 20) {
                        FadeAudio("Porcupine Mines Speed 3 (Loop)", 0, 0.1, 500);
                    } else if (showEvent.currentLevel >= 15) {
                        FadeAudio("Porcupine Mines Speed 2 (Loop)", 0, 0.1, 500);
                    } else {
                        FadeAudio("Porcupine Mines Full B (Loop)", 0, 0.1, 500);
                    }
                    FadeAudio("Porcupine Mines Idle B (Loop)", 0.1, 0, 500);
                }
                break;
            case "mines:spot-selected":
                const spotSelectedEvent = event as ISpotSelectedEvent;
                const timeSinceLastRound = Date.now() - roundStartTime;
                setTimeout(() => {
                    
                    
                    if (spotSelectedEvent.currentWinnings > 0) {
                        const index = Math.min(5, 1 + Math.floor((spotSelectedEvent.currentLevel / 25) * 5));
                        if (spotSelectedEvent.currentLevel === 15) {
                            FadeAudio("Porcupine Mines Full B (Loop)", 0.1, 0, 500);
                            FadeAudio("Porcupine Mines Speed 2 (Loop)", 0, 0.1, 500);
                        }
                        PlayAudio(`Gem ${index}`, false, 0.25);
                        setShowEvent(spotSelectedEvent);
                        setLevel(spotSelectedEvent.currentLevel);
                        setGameResults(spotSelectedEvent.gameResults);
                        setPlayerPicks(spotSelectedEvent.playerPicks);
                        setPending(false);
                    } else {
                        setShowEvent(spotSelectedEvent);
                        setLevel(spotSelectedEvent.currentLevel);
                        setGameResults(spotSelectedEvent.gameResults);
                        setPlayerPicks(spotSelectedEvent.playerPicks);
                        
                        setTimeout(() => {
                            setPending(false);
                        }, timeSinceLastRound > 4000 ? 0 : 4000 - timeSinceLastRound);

                        PlayAudio(`bomb-${1 + Math.floor(Math.random() * 4)}`, false, 0.1);
                        FadeAudio("Porcupine Mines Full B (Loop)", 0.1, 0, 500);
                        FadeAudio("Porcupine Mines Speed 2 (Loop)", 0.1, 0, 100);
                        FadeAudio("Porcupine Mines Speed 3 (Loop)", 0.1, 0, 100);
                        FadeAudio("Porcupine Mines Idle B (Loop)", 0, 0.1, 500);
                    }
                }, 1000);

                break;
            case "mines:collect-winnings":
                const collectWinningsEvent = event as IShowEvent;
                setShowEvent(collectWinningsEvent);
                setGameResults(collectWinningsEvent.gameResults);
                setPlayerPicks(collectWinningsEvent.playerPicks);
                setSessionWinnings(sessionWinnings + collectWinningsEvent.realWinnings - betAmount);
                setLevel(0);
                break;
            case "mines:end-game":
                if (!freePlay) {
                    setSessionLosses(sessionLosses + betAmount);
                }
                setLevel(0);
                setPlaying(false);
                break;
        }
    });

    const playText = () => {
        switch (showEvent?.gameState) {
            case "IN_PLAY":
                return `COLLECT ${formatCurrency(showEvent.currentWinnings)}`;
            case "MAIN":
                if (playing) {
                    return "END";
                } else if (bfrInUse) {
                    return `PLAY (${bfrCount} Free ${bfrCount === 1 ? "Play" : "Plays"})`;
                } else {
                    return "PLAY";
                }
        }
    }

    return (
        <div>
            <Background />
            {!loading &&
                <div>
                    <BackBushesBackground />
                    <BackBushesBackground style={{ transform: "scaleX(-1)", right: "0" }} />
                    <RightOverlayContainer />
                    <LeftOverlayContainer />
                    <PhoneBackground />
                    <MinesSelect
                        open={minesSelectOpen}
                        mineCount={mineCount}
                        mines={Array.from(Array(25).keys()).filter(mine => mine > 1)}
                        onMineSelect={(mine) => setMineCount(mine)}
                        onCloseRequest={() => setMinesSelectOpen(!minesSelectOpen)}
                    />
                    <Game
                        balance={balance}
                        gameName="Mines"
                        bets={bets}
                        bet={betAmount || 0}
                        gameHistoryDetailView={GameHistoryRenderer}
                        rightSideHUD={
                            <MinesChoiceChip disabled={playing || changeMinesDisabled || pending} content={mineCount.toString()} label="Mines" labelFirst={true} onClick={() => setMinesSelectOpen(!minesSelectOpen)} />
                        }
                        supportedOrientations={["DESKTOP_LANDSCAPE", "DESKTOP_PORTRAIT", "MOBILE_PORTRAIT"]}
                        gameAreaWidth={window.innerHeight <= 829 ? "400px" : "100%"}
                        gameAreaHeight={window.innerHeight <= 829 ? "450px" : "646px"}
                        gameVersion="v1.0.0"
                        winnings={sessionWinnings - sessionLosses}
                        gameRulesContent={GameRules}
                        playText={playText()}
                        showPlayIcon={!playing}
                        disableBetChange={playing || pending}
                        disableMenuOpen={playing || pending}
                        gameAreaAutoScale={false}
                        disableHUD={minesSelectOpen || pending}
                        onBetSelect={bet => setBetAmount(bet)}
                        onPlay={async(usingBFRBalance) => {
                            setFreePlay(usingBFRBalance);
                            if (showEvent?.gameState === "IN_PLAY") {
                                PlayAudio("Play Jingle", false, 0.1);
                                setPending(true);
                                collect();
                                FadeAudio("Porcupine Mines Full B (Loop)", 0.1, 0, 500);
                                FadeAudio("Porcupine Mines Idle B (Loop)", 0, 0.1, 500);
                                const timeSinceLastRound = Date.now() - roundStartTime;
                                await Timeout(900 + (timeSinceLastRound > 5000 ? 0 : 5000 - timeSinceLastRound));
                                setPending(false);
                            } else {
                                if (!playing) {
                                    FadeAudio("Porcupine Mines Full B (Loop)", 0, 0.1, 500);
                                    FadeAudio("Porcupine Mines Idle B (Loop)", 0.1, 0, 500);
                                } else {
                                    FadeAudio("Porcupine Mines Full B (Loop)", 0.1, 0, 500);
                                    FadeAudio("Porcupine Mines Idle B (Loop)", 0, 0.1, 500);
                                }
                                roundStartTime = Date.now();
                                setLevel(0);
                                setGameResults(Array(25).fill("NON_DISCOVERED"));
                            }
                            setPlaying(!playing);
                            if (showEvent?.gameState === "MAIN") {
                                await Timeout(4000);
                            }
                        }}
                    >
                        
                        {game(playing, level, betAmount, config, gameResults, mineCount, betAmount, playerPicks, pending, showEvent)}
                    </Game>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Porcupines />
                    </div>
                </div>
            }

            {!showGame && <Splash />}
        </div>


    );
}

export default App;
